module.exports = __webpack_public_path__ + "img/ethernodes.c61a32e9.png";